import type { ButtonStyle } from "../components/Upsell/types";

export function pad(n: number): string {
  return String(n).padStart(2, "0");
}

export function getButtonAnimation(
  type: ButtonStyle["animation"]
): string | undefined {
  switch (type) {
    case "shake":
      return "codway-shake 0.6s ease-in-out 0.25s infinite";
    case "bounce":
      return "codway-bounce 1s ease-in-out 0.25s infinite";
    case "pulse":
      return "codway-pulse 1.5s ease-in-out 0.25s infinite";
    default:
      return undefined;
  }
}
